export default __webpack_public_path__ + "static/media/Green.fe0b1bbc.jpg";